module.exports = __webpack_public_path__ + "img/41.ce9c20c4.webp";